import { LogoIcon } from '@/assets/icons/Logo';
import { cn } from '@/lib/ui/cn';
import type { DirectusFieldTheme } from '@/types/directus';

interface LogoProps {
  className?: string;
  theme?: DirectusFieldTheme;
}

const Logo: React.FC<LogoProps> = ({ className, theme = 'light' }) => {
  const isDark = theme === 'dark';
  const baseClasses = '';
  const darkClasses = 'text-sh-white';
  const lightClasses = 'text-sh-black';

  return (
    <LogoIcon
      data-test='logo'
      className={cn(
        className,
        baseClasses,
        isDark ? darkClasses : lightClasses
      )}
    />
  );
};

export default Logo;
